import { PlusCircleFilled } from '@ant-design/icons';
import React from 'react';
import { useDispatch } from 'react-redux';

import { setterProjectTree } from '../../../store/slices/projectTreeSlice';
import { ItemType } from '../../../types';

interface ClickableIconProps {
    item: ItemType;
}

export const ProjectsTreeCellAddItem: React.FC<ClickableIconProps> = ({ item }) => {
    const dispatch = useDispatch();

    return (
        <PlusCircleFilled
            onClick={(e: React.MouseEvent<HTMLSpanElement>) => {
                e.preventDefault();
                e.stopPropagation();
                dispatch(
                    setterProjectTree({
                        appendIntoItem: item,
                    }),
                );
            }}
            onMouseEnter={() => {
                dispatch(
                    setterProjectTree({
                        appendRequestingItem: item,
                    }),
                );
            }}
            onMouseLeave={() => {
                dispatch(
                    setterProjectTree({
                        appendRequestingItem: null,
                    }),
                );
            }}
            style={{
                position: 'relative',
                top: -1,
                right: -1,
                marginLeft: 8,
                fontSize: 18,
                color: '#555',
                cursor: 'pointer',
            }}
        />
    );
};
